import { FC, useContext } from 'react';

import { Checkbox, H3, Input } from '@smartshell/ui-kit';
import cn from 'classnames';
import { Controller } from 'react-hook-form';

import { LocalizationContext } from 'localization';

import s from '../Tariff.module.scss';
import { ITariffTitleSectionsProps } from './interfaces';

export const TariffTitleSections: FC<ITariffTitleSectionsProps> = ({
  control,
}) => {
  const { t } = useContext(LocalizationContext);

  return (
    <div className={s['form-block']}>
      <H3 className={s.header}>{t('tariff.title')}</H3>
      <div className={cn(s.fields, s.title)}>
        <Controller
          control={control}
          render={({ field, fieldState: { error } }) => (
            <Input
              {...field}
              title={t('tariff.title')}
              placeholder={t('tariff.title.placeholder')}
              error={error?.message}
              className={s.field}
              bordered
            />
          )}
          name="title"
          rules={{
            required: t('errors.required'),
            minLength: {
              value: 2,
              message: t('errors.minLength', 2),
            },
            maxLength: {
              value: 24,
              message: t('errors.maxLength', 24),
            },
          }}
        />
        <Controller
          control={control}
          render={({ field: { ref, ...field } }) => (
            <Checkbox {...field} label={t('tariff.active')} />
          )}
          name="is_active"
        />
      </div>
    </div>
  );
};
